import { useRequest } from 'liyu-pc-base/init-plugin';

export async function queryRoleAndPerson(params?: { [key: string]: any }): Promise<RoleResponse> {
  return useRequest().post('/permission/query_role_and_person_list', params);
}

export async function removeRole(params: Record<string, any>) {
  return useRequest().post('/permission/delete_role', params);
}
export async function recoverRole(params: Record<string, any>) {
  return useRequest().post('/permission/recover_role', params);
}
export async function query_role_and_person_by_admin_list(params?: {
  [key: string]: any;
}): Promise<RoleResponse> {
  return useRequest().post('/permission/query_role_and_person_by_admin_list', params);
}

export async function addRole(params: Record<string, any>) {
  return useRequest().post('/permission/create_role', params);
}

export async function updateRole(params: Record<string, any>) {
  return useRequest().post('/permission/update_role', params);
}
export async function copy_role_info(params: Record<string, any>) {
  return useRequest().post('/permission/copy_role_info', params);
}
export async function import_role(params: Record<string, any>) {
  return useRequest().post('/permission/import_role', params);
}
export async function import_role_by_super(params: Record<string, any>) {
  return useRequest().post('/permission/import_role_by_super', params);
}
export async function export_role_by_super(params: Record<string, any>) {
  return useRequest().post('/permission/export_role_by_super', params);
}
interface RuleItem {
  key: string | number;
  callNo: number;
  avatar: string;
  desc: string;
  disabled: false;
  href: string;
  name: string;
  owner: string;
  progress: number;
  status: number;
  updatedAt: string;
  createdAt: string;
}

interface RoleResponse {
  current: number;
  data: RuleItem[];
  pageSize: string;
  success: boolean;
  total: number;
}
